import { Box, Button, Checkbox, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { GoPaperAirplane } from 'react-icons/go'

interface ModalAssinanteProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  setCargo: (nome: string, email: string, visualizarAssinar: boolean, temCadastro: boolean) => void
}

export const ModalAssinante: React.FC<ModalAssinanteProps> = ({ isOpen, onOpen, onClose, setCargo }) => {
  const [visualizarAssinar, setVisualizarAssinar] = useState(false)
  const [nomeAssinante, setNomeAssinante] = useState('')
  const [emailAssinante, setEmailAssinante] = useState('')
  const toast = useToast()

  function adicionarAssinante(): void {
    setCargo(nomeAssinante, emailAssinante, visualizarAssinar, false)
    onClose()
  }

  function validarCampos(): void {
    const nomeValido = nomeAssinante.trim() !== ''
    const emailValido = emailAssinante.trim() !== '' && emailAssinante.includes('@')

    if (!nomeValido || !emailValido) {
      toast({
        title: 'Preencha um nome e um e-mail válido.',
        duration: 4000,
        status: 'error',
        position: 'top'
      })
      return
    }

    adicionarAssinante()
  }

  useEffect(() => {
    setVisualizarAssinar(false)
    setNomeAssinante('')
    setEmailAssinante('')
  }, [isOpen])

  return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW={'750px'}>
          <ModalHeader color={'blue.400'} fontSize={'3xl'} fontWeight={'bold'}>Adicione uma nova assinatua</ModalHeader>
          <ModalCloseButton color={'black'} bgColor={'white'}/>

          <ModalBody>
            <Box display={'flex'} flexDirection={'column'}>
                <Box display={'flex'} flexDirection={'row'} gap={'2rem'}>
                  <FormControl>
                    <FormLabel>Nome</FormLabel>
                    <Input type={'text'} onChange={(e) => setNomeAssinante(e.target.value)} placeholder="Nome do assinante"/>
                  </FormControl>
                  <FormControl>
                    <FormLabel>E-mail</FormLabel>
                    <Input type={'email'} onChange={(e) => setEmailAssinante(e.target.value)} placeholder="Email do assinante"/>
                  </FormControl>
                </Box>
                <Checkbox
                    isChecked={visualizarAssinar}
                    onChange={(e) => setVisualizarAssinar(e.target.checked)}
                    maxW={'13rem'}
                    mt={'1.5rem'}
                >
                    Visualizar e assinar trilha
                </Checkbox>
                <Text ml={'1.5rem'} fontSize={'sm'} color={'gray.500'}>O revisor poderá visualizar a trilha e solicitar ajustes</Text>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose} bgColor={'gray.500'} >
              Cancelar
            </Button>
            <Button bgColor={'green.500'} leftIcon={<GoPaperAirplane />} onClick={validarCampos}>
              Enviar solicitação
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}
